import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import visionTestCardImg from '../../Assets/Img/visionTestCardImg.png';
import { DonutChart } from './donut-chart';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useEyetestCountMutation } from '../Eyetest/eyetestApi';
import { useSelector } from 'react-redux';
import { getSecureItem } from "../../utils/secureStorage";
const TestDetails = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const user = getSecureItem('UserData');
    const eyetestCount = useSelector((state) => state.eyetest);

    const approvedEyetests = eyetestCount.count[0];
    const notApprovedEyetests = eyetestCount.count[1];
    const totalEyetests = eyetestCount.count[2];
    const unassignedEyetests = eyetestCount.count[3];
    const assignedEyetests = eyetestCount.count[4];
    const doctortotalEyetests =
        assignedEyetests + notApprovedEyetests + approvedEyetests;
    // const pieChartTotal = approvedEyetests + pendingValidationEyetests + unassignedEyetests;
    const piechartValues = [
        approvedEyetests,
        assignedEyetests,
        notApprovedEyetests,
        unassignedEyetests,
    ];
    const piechartValuesDoc = [
        approvedEyetests,
        assignedEyetests,
        notApprovedEyetests,
    ];
    const colors = [
        '#072CAB', // Bootstrap success
        '#6C8CF9', // Bootstrap warning
        '#D0D5DD', // Bootstrap danger
        '#888b8f',
    ];
    const colorDoc = [
        '#072CAB',
        '#6C8CF9', // Bootstrap success
        '#888b8f', // Bootstrap warning
    ];

    // const docPiechartValues = [totalEyetests, assignedEyetests];

    return (
        <Card className="mb-4">
            <Card.Header
                className="bg-white d-flex align-items-center"
                style={{ height: '50px' }}
            >
                <div className="d-flex align-items-center gap-2">
                    <div className="cardImgContainer d-flex align-items-center justify-content-center">
                        <img
                            src={visionTestCardImg}
                            style={{ height: '20px' }}
                        />
                    </div>
                    <Card.Title className="mb-0">{t('visionTest')}</Card.Title>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col
                        md={6}
                        className="d-flex align-items-center justify-content-center"
                    >
                        <DonutChart
                            values={
                                ['OPTICIAN', 'ADMIN', 'BACKOFFICE'].includes(
                                    user?.userType
                                )
                                    ? piechartValues
                                    : piechartValuesDoc
                            }
                            colors={
                                ['OPTICIAN', 'ADMIN', 'BACKOFFICE'].includes(
                                    user?.userType
                                )
                                    ? colors
                                    : colorDoc
                            }
                        />
                    </Col>
                    <Col md={6} className="d-flex align-items-center">
                        <div
                            style={{ width: '100%' }}
                            className="piechart_text"
                        >
                            {['OPTICIAN', 'ADMIN', 'BACKOFFICE'].includes(
                                user?.userType
                            ) ? (
                                <div
                                    className="d-flex justify-content-between mb-3 align-items-center"
                                    role="button"
                                    onClick={() => navigate('/eyetest/list')}
                                >
                                    <h3>{t('total')}</h3>
                                    <h3>{totalEyetests}</h3>
                                </div>
                            ) : (
                                ''
                            )}
                            {['EYEDOCTOR'].includes(user?.userType) ? (
                                <>
                                    <div
                                        className="d-flex justify-content-between mb-3 align-items-center"
                                        role="button"
                                        onClick={() =>
                                            navigate('/eyetest/list')
                                        }
                                    >
                                        <h3>{t('total')}</h3>
                                        <h3>{doctortotalEyetests}</h3>
                                    </div>
                                     <div
                                        className="d-flex justify-content-between mb-3"
                                        role="button"
                                        onClick={() =>
                                            navigate('/eyetest/list', {
                                                state: {
                                                    status: 'pendingValidation',
                                                },
                                            })
                                        }
                                    >
                                        <p
                                            className="m-0"
                                            style={{ color: '#6C8CF9' }}
                                        >
                                            {t('pendingValidation')}
                                        </p>
                                        <h5 className="m-0">
                                            {assignedEyetests}
                                        </h5>
                                    </div>
                                    <div
                                        className="d-flex justify-content-between mb-3"
                                        role="button"
                                        onClick={() =>
                                            navigate('/eyetest/list', {
                                                state: { status: 'approved' },
                                            })
                                        }
                                    >
                                        <p
                                            className="m-0"
                                            style={{ color: '#072CAB' }}
                                        >
                                            {t('approveds')}
                                        </p>
                                        <h5 className="m-0">
                                            {approvedEyetests}
                                        </h5>
                                    </div>
                                </>
                            ) : (
                                ''
                            )}

                            {['OPTICIAN', 'ADMIN', 'BACKOFFICE'].includes(
                                user?.userType
                            ) ? (
                                <>
                                <div
                                        className="d-flex justify-content-between mb-3"
                                        role="button"
                                        onClick={() =>
                                            navigate('/eyetest/list', {
                                                state: { status: 'unassigned' },
                                            })
                                        }
                                    >
                                        <p
                                            className="m-0"
                                            style={{ color: '#888b8f' }}
                                        >
                                            {t('unassigned')}
                                        </p>
                                        <h5 className="m-0">
                                            {unassignedEyetests}
                                        </h5>
                                    </div>
                                 <div
                                        className="d-flex justify-content-between mb-3"
                                        role="button"
                                        onClick={() =>
                                            navigate('/eyetest/list', {
                                                state: {
                                                    status: 'pendingValidation',
                                                },
                                            })
                                        }
                                    >
                                        <p
                                            className="m-0"
                                            style={{ color: '#6C8CF9' }}
                                        >
                                            {t('pendingValidation')}
                                        </p>
                                        <h5 className="m-0">
                                            {assignedEyetests}
                                        </h5>
                                    </div>
                                    <div
                                        className="d-flex justify-content-between mb-3"
                                        role="button"
                                        onClick={() =>
                                            navigate('/eyetest/list', {
                                                state: { status: 'approved' },
                                            })
                                        }
                                    >
                                        <p
                                            className="m-0"
                                            style={{ color: '#072CAB' }}
                                        >
                                            {t('approveds')}
                                        </p>
                                        <h5 className="m-0">
                                            {approvedEyetests}
                                        </h5>
                                    </div>
                                    <div
                                        className="d-flex justify-content-between mb-3"
                                        role="button"
                                        onClick={() =>
                                            navigate('/eyetest/list', {
                                                state: {
                                                    status: 'notApproved',
                                                },
                                            })
                                        }
                                    >
                                        <p
                                            className="m-0"
                                            style={{ color: '#D0D5DD' }}
                                        >
                                            Tests refusés
                                        </p>
                                        <h5 className="m-0">
                                            {notApprovedEyetests}
                                        </h5>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {[
                                        'OPTICIAN',
                                        'ADMIN',
                                        'BACKOFFICE',
                                    ].includes(user?.userType) ? (
                                        <div
                                            className="d-flex justify-content-between mb-3"
                                            role="button"
                                            onClick={() =>
                                                navigate('/eyetest/list', {
                                                    state: {
                                                        status: 'assigned',
                                                    },
                                                })
                                            }
                                        >
                                            <p
                                                className="m-0"
                                                style={{ color: '#6C8CF9' }}
                                            >
                                                Nouveau tests de vue{' '}
                                            </p>
                                            <h5 className="m-0">
                                                {assignedEyetests}
                                            </h5>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    <div
                                        className="d-flex justify-content-between mb-3"
                                        role="button"
                                        onClick={() =>
                                            navigate('/eyetest/list', {
                                                state: {
                                                    status: 'notApproved',
                                                },
                                            })
                                        }
                                    >
                                        <p
                                            className="m-0"
                                            style={{ color: '#888b8f' }}
                                        >
                                            Tests refusés
                                        </p>
                                        <h5 className="m-0">
                                            {notApprovedEyetests}
                                        </h5>
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};
export default TestDetails;
